import Radio from 'backbone.radio';
import CreateDeploymentDialog from '@/views/dialogs/create_deployment';
import PaginationControls from '@/views/pagination_controls';

var globalCh = Radio.channel('global');
var apiCh = Radio.channel('api');

/**
 * Show a dialog to create a device group.
 * Requires a devicegroup
 * optional deployment, will not show deployment picker
 */
export default function show_create_deployment(devicegroup, deployment) {
    const deployments = apiCh.request('deployment');
    var controls_view = new PaginationControls({
        collection: deployments
    });

    var product = devicegroup.rel.get('product');
    var fetch_filter;
    switch (devicegroup.type) {
        case devicegroup.TYPES_MAP.pre_production:
            fetch_filter = {
                'filter[devicegroup.type]': `${devicegroup.TYPES_MAP.pre_production},${devicegroup.TYPES_MAP.development}`,
                'filter[product.id]': product.id,
            };
            break;
        case devicegroup.TYPES_MAP.production:
            fetch_filter = {
                'filter[flagged]': true,
                'filter[devicegroup.type]': `${devicegroup.TYPES_MAP.development},${devicegroup.TYPES_MAP.production},${devicegroup.TYPES_MAP.pre_production}`,
                'filter[product.id]': product.id,
            };
            break;
        case devicegroup.TYPES_MAP.dut:
            fetch_filter = {
                'filter[flagged]': true,
                'filter[devicegroup.type]': `${devicegroup.TYPES_MAP.development},${devicegroup.TYPES_MAP.dut},${devicegroup.TYPES_MAP.pre_dut}`,
                'filter[product.id]': product.id,
            };
            break;
        case devicegroup.TYPES_MAP.pre_dut:
            fetch_filter = {
                'filter[devicegroup.type]': `${devicegroup.TYPES_MAP.development},${devicegroup.TYPES_MAP.dut},${devicegroup.TYPES_MAP.pre_dut}`,
                'filter[product.id]': product.id,
            };
            break;
        case devicegroup.TYPES_MAP.factoryfixture:
            fetch_filter = {
                'filter[flagged]': true,
                'filter[devicegroup.type]': `${devicegroup.TYPES_MAP.pre_factoryfixture},${devicegroup.TYPES_MAP.factoryfixture}`,
                'filter[product.id]': product.id,
            };
            break;
        case devicegroup.TYPES_MAP.pre_factoryfixture:
            fetch_filter = {
                'filter[devicegroup.type]': `${devicegroup.TYPES_MAP.pre_factoryfixture}`,
                'filter[product.id]': product.id,
            };
            break;
        case devicegroup.TYPES_MAP.development:
            fetch_filter = {
                'filter[devicegroup.type]': `${devicegroup.TYPES_MAP.development}`,
                'filter[product.id]': product.id,
            };
            break;
        default:
            fetch_filter = {
                'filter[product.id]': product.id,
            };
            break;
    }
    var deployment_dialog;
    if (deployment && deployment.type === 'deployment'){
        if (devicegroup.type === devicegroup.TYPES_MAP.pre_factoryfixture) {
            deployment_dialog = new CreateDeploymentDialog({
                devicegroup: devicegroup,
                product: product,
                deployment: deployment,
                collection: deployments,
                pagination_controls: controls_view,
                pre_factoryfixture_devicegroup: devicegroup,
            });
        } else {
            deployment_dialog = new CreateDeploymentDialog({
                devicegroup: devicegroup,
                product: product,
                deployment: deployment,
                collection: deployments,
                pagination_controls: controls_view,
            });
        }
            globalCh.request('showDialog', deployment_dialog);
    } else {
    // We need to do something about our pagination success vs then logic
    deployments.fetch({
        remove: false,
        data: fetch_filter,
    })
    .done(
        function(){
            controls_view.update_prev_next_from_response;
            if (devicegroup.type === devicegroup.TYPES_MAP.pre_factoryfixture || devicegroup.type === devicegroup.TYPES_MAP.pre_production) {
                deployment_dialog = new CreateDeploymentDialog({
                    devicegroup: devicegroup,
                    product: product,
                    collection: deployments,
                    pagination_controls: controls_view,
                    pre_factoryfixture_devicegroup: devicegroup
                });
            } else {
                deployment_dialog = new CreateDeploymentDialog({
                    devicegroup: devicegroup,
                    product: product,
                    collection: deployments,
                    pagination_controls: controls_view,
                });
            }

            globalCh.request('showDialog', deployment_dialog);

        }
    );
    }
}

